module.exports = __webpack_public_path__ + "static/media/slider-right-white.4d144422.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/slider-right-white.svg
// module id = 318
// module chunks = 0